<div *ngIf="processing">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>

<div *ngIf="!processing">
  <div class="flex flex-row gap-2 justify-start items-center mb-4">
    <h1 class="portal-page-title">Pay Online</h1>
  </div>

  <mat-card *ngIf="isValid">
    <mat-card-content>
      <div class="flex flex-col">
        <span class="text-lg font-semibold pb-4">NOTE:</span>
        <span>When ready to pay click the '{{proceedButtonText}}' Button below.</span>
        <span>You will then be redirected to our 3rd party payment processor.</span>
        <span>Once payment is complete you will be redirected back to this site for further instructions.</span>
      </div>
    </mat-card-content>
    <!-- <span ><strong>NOTE:</strong> <br/><br />
      <ul>
        <li>When ready to pay click the '{{proceedButtonText}}' Button below. </li>
        <li>You will then be redirected to our 3rd party payment processor.  </li>
        <li>Once payment is complete you will be redirected back to this site for further instructions.</li>
      </ul>
    </span> -->
  </mat-card>

  <mat-card class="portal-notice" *ngIf="!isValid">
    <span ><strong> No pending payments found.</strong>
    </span>
  </mat-card>

  <div class="pt-4" *ngFor="let payment of payments">
    <mat-card class="pb-2">
      <mat-card-header>
        <mat-card-title>
          <div class="flex flex-row gap-2 justify-start items-center mb-4">
            <span>{{payment.entityId}} ({{payment.entityName}}) - {{paymentService.getPaymentTypeDescription(payment.sku)}}</span>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-row gap-2 justify-start items-center mb-4">
          <span *ngIf="!payment.paid">
            <button mat-stroked-button type='button' (click)="payNow(payment.id, payment.entityType)" color="primary">{{proceedButtonText}}: $ {{payment.amount}}</button>
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
